import { render, staticRenderFns } from "./Tab2Columns.vue?vue&type=template&id=ef4432cc&"
import script from "./Tab2Columns.vue?vue&type=script&lang=js&"
export * from "./Tab2Columns.vue?vue&type=script&lang=js&"
import style0 from "./Tab2Columns.vue?vue&type=style&index=0&id=ef4432cc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports